export * from './searchResults.component';
